export const PercutaneousPenetrationAnswer = "PercutaneousPenetration";

export const PepRiskAssessmentQuestionsOptions = {
    PepNatureOfExposure: [
        { text: "Percutaneous Penetration", value: PercutaneousPenetrationAnswer, pepScore: 2 },
        { text: "Splash to broken skin or mucosal membrane", value: "SplashBrokenSkinMucosalMembrane", pepScore: 1 },
    ],
    PepMaterialExposedTo: [
        { text: "Blood or blood stained fluid", value: "BloodOrBloodStainedFluid", pepScore: 2 },
        { text: "Non bloody bodily fluid excluding faeces, saliva, urine vomit", value: "NonBloodyBodilyFluid", pepScore: 0 },
    ],
    PepTypeOfSharp: [
        { text: "Hollow device no gloves", value: "HollowDeviceNoGloves", pepScore: 2 },
        { text: "Hollow device through gloves", value: "HollowDeviceThroughGloves", pepScore: 1 },
        { text: "Solid device no gloves", value: "SolidDeviceNoGloves", pepScore: 1 },
        { text: "Solid device through gloves", value: "SolidDeviceThroughGloves", pepScore: 0 }
    ],
    PepSharpsUsed: [
        { text: "IV / Arterial Access / Inside Organs", value: "IvArterialAccessInsideOrgans", pepScore: 1 },
        { text: "Skin Suture / IM / Sub-Cut", value: "SkinSutureImSubCut", pepScore: 0 }
    ],
    PepWoundDescription: [
        { text: "Deep", value: "Deep", pepScore: 3 },
        { text: "Moderate (Penetrated Skin)", value: "Moderate", pepScore: 2 },
        { text: "Superficial (Scratch/Graze)", value: "Superficial", pepScore: 1 }
    ],
    PepRiskFactorsForHiv: [
        { text: "High Risk Factors", value: "HighRiskFactors", pepScore: 5 },
        { text: "Low Risk Factors / Unknown", value: "LowRiskFactors", pepScore: 1 },
        { text: "Known HIV Positive", value: "KnownHivPositive", pepScore: 6 }
    ]
};
